// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueResource from "vue-resource";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueQuillEditor, { Quill } from "vue-quill-editor";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import ElementUI from "element-ui";
import echarts from "echarts";
import "element-ui/lib/theme-default/index.css";
import "swiper/dist/css/swiper.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

import App from "./App";
import router from "./router"; //引入路由配置文件
import "./public/static/css/reset.css";
import "./public/static/css/animate.min.css";
import store from "./store";

Vue.use(PerfectScrollbar, {
  options: {
    suppressScrollX: true,
    minScrollbarLength: 20
  }
});
const Font = Quill.import("attributors/style/font");
Font.whitelist = [
  "porsche-font",
  "thin-porsche-font",
  "porsche-next-tt-bold",
  "黑体"
];
Quill.register(Font, true);
Vue.use(VueAwesomeSwiper /* { default global options } */);
//设置
const globalOption = {
  placeholder: "请输入",
  modules: {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { size: [] },
          {
            font: [
              "porsche-font",
              "thin-porsche-font",
              "porsche-next-tt-bold",
              "黑体"
            ]
          }
        ],
        [{ color: [] }, { background: [] }],
        [{ align: [] }]
      ]
    }
  }
};
Vue.use(VueQuillEditor, globalOption);
Vue.use(echarts);
//Vue.prototype.$echarts = echarts
Vue.use(VueResource);
Vue.config.productionTip = false;
Vue.config.devtools = true;
if (!window.Promise) window.Promise = require("es6-promise");
Vue.filter("currency", function(value) {
  if (!value) {
    return "0";
  }
  return value.toFixed(2);
});

Vue.filter("deleteSharp", value => {
  if (!value) {
    return "/";
  }
  return value.replace(/#/g, "");
});

Vue.filter("percentage", function(value) {
  if (!value) {
    return "";
  }
  return Math.round(value.toFixed(2) * 100) + "%";
});

Vue.filter("FillZero", function(value) {
  return value < 10 ? "0" + value : value;
});

Vue.filter("removeNameSuffix", function(value) {
  var suffix = "保时捷中心";
  if (value != null && value.indexOf(suffix) > 0) {
    return value.replace(suffix, "");
  }
  return value;
});

Vue.filter("imageVersion", function(value, version) {
  var v =
    version != null
      ? version
      : new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
  return value + "?v=" + v;
});

var env = __env__;
var projEnv = require(`../config/${env}.env`);

Vue.prototype.getConfig = () => {
  return projEnv;
};

export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}

Vue.prototype.formatSolution = function(s) {
  if (s) {
    return s.replace(/\n/g, "<br/>");
  } else return "";
};

Vue.use(ElementUI);

/* eslint-disable no-new */
window.$vm = new Vue({
  el: "#app",
  router, // 注入到根实例中
  ElementUI,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js